import { Container, Col, Row } from 'react-bootstrap';
import image from './image.jpg';
import './About.css';
import { useAppSelector } from '../../../app/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile } from '@fortawesome/free-solid-svg-icons';

const About = () => {

  const resize = useAppSelector(state => state.navbar.resize);
  return (
    <Container className='about-wrapper' fluid style={{
      marginLeft: resize ? '0' : '20rem',
      width: resize ? '' : 'calc(100vw - 20rem)',
      backgroundColor: 'rgb(8, 13, 19)',
      height: '100vh',
      paddingBottom: '10rem',
      paddingRight: '0',
      paddingLeft: '0',
    }}>
      <Row className='flex-lg-row' lg={12}>
        <Col xs={12} sm={12} md={12} lg={12} className='d-flex'>
          <div className='title fs-4 text-success text-start m-4 p-4 border border-light rounded w-100'>
            <Row>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} className='order-lg-2'>
                <h1 className='text-light fs-2'>About Me</h1>
                <h3 className='fs-4'>Hi there! I'm Farid Firoz, a Software Developer based in Perth, Australia.</h3>
                <h3 className='fs-4'>I enjoy creating things that live on the internet, whether that be websites, applications, or anything in between. My goal is to always build products that provide pixel-perfect (haha), performant experiences.</h3>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} xl={4} xxl={2} className='h-100 m-auto order-lg-1'>
                <img src={image} alt="Farid Firoz" className="rounded-circle img-fluid" style={{
                  maxWidth: '100%',
                  height: 'auto',
                }} />
              </Col>
            </Row>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12} className='d-flex'>
          <div className='title fs-4 text-success text-start m-4 p-4 border border-light rounded w-100'>
            <h1 className='text-light fs-2'>Recent work as a Software Developer <FontAwesomeIcon icon={faSmile} /></h1>
            <h3>Junior Full Stack Developer at ATOM: Feb 2024 - Dec 2024</h3>
            <div className="code text-success bg-black p-2 rounded-2">
              <ul>
                <li>
                  Led a project to integrate freight data into the system, sanitizing and processing it 
                  according to stakeholder-defined business rules. Developed an automated approval 
                  system with notifications to relevant parties, and provided a user interface for data 
                  management and analytics, featuring a commenting system and approval stages.
                </li>
                <li>
                  Reduced development time for new user controls by 50% when implementing user 
                  interfaces by creating templates with pre-defined common functionality, minimizing the 
                  likelihood of errors during testing.
                </li>
                <li>
                  Worked on front-end development using .NET Framework and web interfaces with React, 
                  created Windows background services, and handled backend tasks including database 
                  design, stored procedures, views, and SSRS report creation
                </li>
                <li>
                  Refactored over 6,000 lines of code down to 1,000 by designing a mapping system that 
                  improved the navigation and implementation of user controls, utilizing Generics and 
                  Reflection.
                </li>
                <li>
                  Enhanced the codebase by creating reusable common methods using Generics.
                </li>
              </ul>
            </div>
          </div>
        </Col>
        <Col lg={12} md={12} sm={12} xs={12} className='d-flex'>
          <div className='title fs-4 text-success text-start m-4 p-4 border border-light rounded w-100'>
            <h1 className='text-light fs-2'>What are my skills?</h1>
            <h3>Here are a few technologies I've been working with recently:</h3>
            <div className='code text-success bg-black p-2 rounded-2'>
              <div className="fs-5">Front End</div>
              <ul>
                <li>JavaScript (ES6+)</li>
                <li>React</li>
                <li>React Native</li>
                <li>Redux Toolkit</li>
                <li>TypeScript</li>
                <li>Node.js</li>
                <li>Express</li>
                <li>HTML & CSS</li>
                <li>Bootstrap</li>
                <li>GitHub</li>
                <li>C# - .Net Framework, .Net Core, ASP.Net</li>
                <li>VBA</li>
                <li>Sap Gui Scripting</li>
              </ul>
              <div className="fs-5">Back End</div>
              <ul>
                <li>SQL</li>
                <li>MongoDB</li>
                <li>Firebase</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
